import { createGlobalStyle } from "styled-components";

//
import "./color.css";
import "./icon.css";


const GlobalStyle = createGlobalStyle`
    :root {
        --fs-page-title: clamp(32px, 3.2vw, 52px);
        --fs-section-title: clamp(30px, 2.8vw, 46px);
        --fs-card-title: clamp(20px, 1.6vw, 24px);
        --fs-subtitle: clamp(16px, 1.2vw, 20px);
        --fs-body-lg: clamp(18px, 1.35vw, 24px);
        --fs-body: 18px;
        --fs-body-sm: 15px;

        --lh-title: 1.18;
        --lh-subtitle: 1.5;
        --lh-body: 1.55;
        --lh-body-lg: 1.55;

        --fw-regular: 400;
        --fw-medium: 500;
        --fw-semibold: 600;

        --space-title-subtitle: 16px;
        --space-heading-body: 24px;
        --space-section-content: 48px;
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: "Montserrat", serif;
    }

    html {
        scroll-behavior: smooth;
    }

    body {
        background-color: var(--bg);
    }

    .type-page-title {
        font-size: var(--fs-page-title);
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
    }

    .type-section-title {
        font-size: var(--fs-section-title);
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
    }

    .type-section-subtitle {
        font-size: var(--fs-subtitle);
        font-weight: var(--fw-regular);
        line-height: var(--lh-subtitle);
    }

    .type-card-title {
        font-size: var(--fs-card-title);
        font-weight: var(--fw-semibold);
        line-height: 1.35;
    }

    .type-body {
        font-size: var(--fs-body);
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
        text-align: left;
    }

    .type-body-lg {
        font-size: var(--fs-body-lg);
        font-weight: var(--fw-regular);
        line-height: var(--lh-body-lg);
        text-align: left;
    }

    .type-small {
        font-size: var(--fs-body-sm);
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
    }

    ul {
        list-style: none;
    }

    a {
        text-decoration: none;
        color: var(--white);
    }

    .hover-underline {
        position: relative;

        &::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0px;
            width: 0;
            height: 1px;
            background-color: var(--white);
            transition: 0.4s ease;
        }

        &:hover {
            &::after {
                width: 100%;
            }
        }
    }

    .container {
        max-width: 1400px;
        margin: 0 auto;
        padding: 0 32px;

        @media (max-width: 1200px) {
            padding: 0 24px;
        }

        @media (max-width: 768px) {
            padding: 0 20px;
        }

        @media (max-width: 480px) {
            padding: 0 16px;
        }
    }
`;

export default GlobalStyle;
